import Modal from 'comp/modal';
import {Button} from 'comp/button';

import React from 'react';
import ReactDOM from 'react-dom';
import Portal from 'react-portal';
import _ from 'lodash';

import {modalUrls} from './sandbox-config';
import styles from './sandbox.scss';

export default function showSandboxMessage(iframeSource) {
  const backButton = (
    <Button key='back' type='secondary' size='large' closeModal>Take me back to the builder</Button>
  );

  const pricingButton = (
    <Button key='pricing' type='action' size='large' href='//unbounce.com/pricing' target='_blank'>
      Start a free trial
    </Button>
  );

  let modalContainer = _.first(document.getElementsByClassName('modal-portal'));

  if (typeof modalContainer === 'undefined') {
    modalContainer = document.createElement('div');
    modalContainer.className = 'modal-portal';
    document.body.appendChild(modalContainer);
  }

  ReactDOM.render(
    <Portal isOpened closeOnEsc closeOnOutsideClick>
      <Modal
        title="Sign up for Unbounce"
        modalFooter={[backButton, pricingButton]}
      >
        <iframe
          src={modalUrls[iframeSource]}
          className={styles.iframe}
        />
      </Modal>
    </Portal>, modalContainer);
}



// WEBPACK FOOTER //
// ./src/control/sandbox/sandbox-modal.jsx